import { CallWebhookEditor as CallWebhookEditorRefresh } from './CallWebhookEditorRefresh';

export const CallWebhookEditor = (props) => {
  return <CallWebhookEditorRefresh {...props} />;
};
